var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getConfigByLanguage } from "./config/config.js";
import validationClasses from "./config/validationClasses.js";
import FormValidator from "./lib/formValidator.js";
import * as util from "./lib/utility.js";
/**
 * フォームのバリデーションと送信ボタンの制御を行うクラス
 * @class TopValidation
 * @extends FormValidator
 */
export default class TopValidation extends FormValidator {
    /**
     * コンストラクタ
     * @param {object} config - 設定オブジェクト
     * @param {object} config.zipList - 郵便番号と住所のリスト
     * @param {string} config.zipList.zip - 郵便番号
     * @param {string} config.zipList.address01 - 住所の第一部分
     * @param {string} config.zipList.address02 - 住所の第二部分
     * @param {string} [config.language='ja'] - 使用する言語 {default: 'ja'}
     * @param {boolean} config.debugs - デバッグモード {default: false}
     */
    constructor(config) {
        var _a, _b, _c, _d;
        const { validationConfig, noInputConfig } = getConfigByLanguage((_a = config.language) !== null && _a !== void 0 ? _a : "ja");
        super(validationConfig, noInputConfig);
        this.zipList = config.zipList;
        this.debugs = (_b = config.debugs) !== null && _b !== void 0 ? _b : false;
        this.btnSubmit = document.querySelector(`.${validationClasses.btnSubmit}`);
        this.cloneSubmit = (_c = this.btnSubmit) === null || _c === void 0 ? void 0 : _c.cloneNode(true);
        this.allFields = document.querySelectorAll(`.${this.validationConfig.required.check}, .${this.validationConfig.anyRequired.check}, .${this.validationConfig.tel.check}, .${this.validationConfig.mail.check}, .${this.validationConfig.num.check}, .${this.validationConfig.alphabet.check}, .${this.validationConfig.alphaNum.check}, .${this.validationConfig.zip.check}, .${this.validationConfig.kana.check}, .${this.validationConfig.hiragana.check}, .${this.validationConfig.katakana.check}, .${this.validationConfig.file.check}`);
        const excludedClasses = (_d = this.validationConfig.formArea.excludedClasses) !== null && _d !== void 0 ? _d : {};
        const flatExcludedClasses = Object.values(excludedClasses).flat();
        if (!this.form) {
            console.error({ error: "フォームタグが存在しません。", form: this.form });
            return;
        }
        if (util.isExcludedClasses(flatExcludedClasses)) {
            return;
        }
        if (!this.btnSubmit) {
            console.error({
                error: `.${validationClasses.btnSubmit}が存在しません。`,
                btnSubmit: this.btnSubmit,
            });
            return;
        }
        if (this.debugs)
            console.log(this.form, this.btnSubmit);
        this.init();
    }
    /**
     * 初期化
     * @method init
     * @returns {void}
     */
    init() {
        var _a, _b, _c, _d, _e;
        (_a = this.form) === null || _a === void 0 ? void 0 : _a.classList.add((_b = this.validationConfig.formArea.check) !== null && _b !== void 0 ? _b : "");
        (_c = this.form) === null || _c === void 0 ? void 0 : _c.addEventListener("keydown", (event) => {
            if (event.key === "Enter" && event.target !== this.btnSubmit) {
                const target = event.target;
                if (target && target.tagName !== "TEXTAREA") {
                    event.preventDefault();
                }
            }
        });
        const isFileFields = Array.from(this.allFields).some((field) => { var _a; return field.classList.contains((_a = this.validationConfig.file.check) !== null && _a !== void 0 ? _a : ""); });
        if (isFileFields) {
            (_d = this.form) === null || _d === void 0 ? void 0 : _d.classList.add((_e = this.validationConfig.upload.check) !== null && _e !== void 0 ? _e : "");
        }
        this.toggleSubmitButton();
        this.autoFillAddress();
        this.addValidateEvents();
    }
    /**
     * バリデーションチェックを行うフィールドを再取得するメソッド
     * @method refresh
     * @returns {void}
     */
    refresh() {
        const currentAllFields = this.allFields;
        this.allFields = document.querySelectorAll(`.${this.validationConfig.required.check}, .${this.validationConfig.anyRequired.check}, .${this.validationConfig.tel.check}, .${this.validationConfig.mail.check}, .${this.validationConfig.num.check}, .${this.validationConfig.alphabet.check}, .${this.validationConfig.alphaNum.check}, .${this.validationConfig.zip.check}, .${this.validationConfig.kana.check}, .${this.validationConfig.hiragana.check}, .${this.validationConfig.katakana.check}, .${this.validationConfig.file.check}`);
        const addedFields = Array.from(this.allFields).filter((field) => !Array.from(currentAllFields).includes(field));
        const removedFields = Array.from(currentAllFields).filter((field) => !Array.from(this.allFields).includes(field));
        if (addedFields.length > 0) {
            this.addValidateEvents(util.convertArrayToNodeList(addedFields));
        }
        if (removedFields.length > 0) {
            removedFields.forEach((field) => {
                const shouldRemoveClass = Object.values(this.validationConfig).some((config) => config.check && !field.classList.contains(config.check));
                if (shouldRemoveClass) {
                    this.removeErrorMessage(field);
                    field.classList.remove(validationClasses.through);
                }
            });
            this.addValidateEvents(this.allFields);
        }
        this.toggleSubmitButton();
        if (this.debugs)
            console.log("refreshed");
    }
    /**
     * 住所を自動入力するメソッド
     * @method autoFillAddress
     * @param {string} [zip=this.zipList.zip] - 郵便番号の入力フィールドの名前
     * @param {string} [address01=this.zipList.address01] - 都道府県の入力フィールドの名前
     * @param {string} [address02=this.zipList.address02] - 住所の入力フィールドの名前
     * @returns {void}
     */
    autoFillAddress(zip = this.zipList.zip, address01 = this.zipList.address01, address02 = this.zipList.address02) {
        const zipInput = document.querySelector(`[name="${zip}"]`);
        const address01Input = document.querySelector(`[name="${address01}"]`);
        const address02Input = document.querySelector(`[name="${address02}"]`);
        if (!zipInput)
            return;
        zipInput === null || zipInput === void 0 ? void 0 : zipInput.addEventListener("keyup", () => __awaiter(this, void 0, void 0, function* () {
            let zipValue = util.toHalfWidth(zipInput.value);
            zipValue = zipValue.replace(/-/g, "");
            zipInput.classList.remove(validationClasses.addrErr);
            if (zipValue && zipValue.length === 7) {
                try {
                    const response = yield fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipValue}`);
                    const data = yield response.json();
                    if (data.results) {
                        zipInput.value = util.toHalfWidth(zipValue);
                        if (address01Input) {
                            const addr = {
                                region: data.results[0].address1,
                                locality: data.results[0].address2,
                                street: data.results[0].address3,
                            };
                            this.fillAddressFields(addr, address01Input, address02Input);
                        }
                    }
                    else {
                        zipInput.classList.add(validationClasses.addrErr);
                    }
                }
                catch (error) {
                    console.error("郵便番号の検索中にエラーが発生しました:", error);
                    zipInput.classList.add(validationClasses.addrErr);
                }
            }
        }));
    }
    /**
     * 住所フィールドに値を設定する
     * @param {object} addr - 住所情報
     * @param {TMLSelectElement | HTMLInputElement} address01Input - 都道府県フィールド
     * @param {HTMLInputElement | null} address02Input - 住所フィールド
     */
    fillAddressFields(addr, address01Input, address02Input) {
        if (address01Input.tagName === "SELECT") {
            const selectElement = address01Input;
            const options = selectElement.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].text === addr.region) {
                    selectElement.selectedIndex = i;
                    break;
                }
            }
            selectElement.focus();
        }
        else if (address01Input.tagName === "INPUT") {
            const inputElement = address01Input;
            inputElement.value = addr.region;
            inputElement.focus();
        }
        this.removeErrorMessage(address01Input);
        if (address02Input) {
            address02Input.value = addr.locality + addr.street;
            address02Input.focus();
            this.removeErrorMessage(address02Input);
        }
    }
    /**
     * イベントリスナーを追加するメソッド
     * @param {NodeListOf<HTMLElement>} [triggerFields=this.allFields] - イベントリスナーを追加するフィールド
     * @method addValidateEvents
     */
    addValidateEvents(triggerFields = this.allFields) {
        triggerFields === null || triggerFields === void 0 ? void 0 : triggerFields.forEach((field) => {
            if ((field.tagName === "SELECT" || field.tagName === "INPUT" || field.tagName === "TEXTAREA") && !field.classList.contains(validationClasses.anyRequired)) {
                if (field.classList.contains(validationClasses.realTime) || field.classList.contains(validationClasses.file)) {
                    this.inputFieldHandler(field);
                }
                else {
                    this.blurFieldHandler(field);
                }
            }
            else {
                this.changeFieldHandler(field);
            }
        });
    }
    /**
     * 入力フィールドのblurイベントを処理するメソッド
     * @method blurFieldHandler
     * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} triggerField - 入力フィールド
     * @returns {void}
     */
    blurFieldHandler(triggerField) {
        triggerField === null || triggerField === void 0 ? void 0 : triggerField.addEventListener("blur", (event) => {
            event.stopPropagation();
            if (this.debugs)
                console.log("blurHandler:", triggerField);
            const validationFlag = this.allCheckValidator(triggerField);
            this.displayErrorMessage(triggerField, validationFlag.err);
            this.toggleSubmitButton();
        });
    }
    /**
     * 入力フィールドのinputイベントを処理するメソッド
     * @method inputFieldHandler
     * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} triggerField - 入力フィールド
     * @returns {void}
     */
    inputFieldHandler(triggerField) {
        triggerField === null || triggerField === void 0 ? void 0 : triggerField.addEventListener("input", (event) => {
            event.stopPropagation();
            if (this.debugs)
                console.log("inputHandler:", triggerField);
            const isRealTime = triggerField.classList.contains(validationClasses.realTime);
            const validationFlag = isRealTime ? this.requiredValidator(triggerField) : this.allCheckValidator(triggerField);
            this.displayErrorMessage(triggerField, validationFlag.err);
            this.toggleSubmitButton();
        });
        if (!triggerField.classList.contains(validationClasses.file)) {
            this.blurFieldHandler(triggerField);
        }
    }
    /**
     * 入力フィールドのchangeイベントを処理するメソッド <.check_any_required | radio | checkbox>
     * @method changeFieldHandler
     * @param {HTMLElement} triggerField - 変更されたフィールド（チェックボックスやラジオボタン）
     * @returns {void}
     */
    changeFieldHandler(triggerField) {
        triggerField === null || triggerField === void 0 ? void 0 : triggerField.addEventListener("change", (event) => {
            event.stopPropagation();
            if (this.debugs)
                console.log("changeHandler:", triggerField);
            const isAnyRequired = triggerField.classList.contains(validationClasses.anyRequired);
            const validationFlag = isAnyRequired ? this.anyRequiredValidator(triggerField) : this.allCheckValidator(triggerField);
            this.displayErrorMessage(triggerField, validationFlag.err);
            this.toggleSubmitButton();
        });
    }
    /**
     * エラーメッセージの表示・非表示を行うメソッド
     * @method displayErrorMessage
     * @param {HTMLElement | HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} field - 入力フィールド
     * @param {string} err - エラーの種類を示す文字列
     * @returns {void}
     */
    displayErrorMessage(field, err) {
        var _a, _b, _c, _d;
        if (err === "") {
            if (field.classList.contains(validationClasses.file)) {
                (_a = this.uploadFields) === null || _a === void 0 ? void 0 : _a.forEach((uploadField) => {
                    if (uploadField.value.trim() !== "") {
                        this.removeErrorMessage(uploadField);
                    }
                });
            }
            else {
                this.removeErrorMessage(field);
            }
        }
        else {
            const errorMessage = (_c = (_b = this.validationConfig[err]) === null || _b === void 0 ? void 0 : _b.errText) !== null && _c !== void 0 ? _c : "";
            if (err === "upload") {
                (_d = this.uploadFields) === null || _d === void 0 ? void 0 : _d.forEach((uploadField) => {
                    this.addErrorMessage(uploadField, errorMessage);
                });
            }
            else {
                this.addErrorMessage(field, errorMessage);
            }
        }
    }
    /**
     * エラーメッセージを削除するメソッド
     * @method removeErrorMessage
     * @param {HTMLElement} elem - エラーメッセージを削除する要素
     * @returns {void}
     */
    removeErrorMessage(elem) {
        elem.classList.remove(validationClasses.err);
        elem.classList.add(validationClasses.through);
        const errText = elem.nextElementSibling;
        if (errText === null || errText === void 0 ? void 0 : errText.classList.contains(validationClasses.err)) {
            errText.remove();
        }
    }
    /**
     * エラーメッセージを追加するメソッド
     * @method addErrorMessage
     * @param {HTMLElement} elem - エラーメッセージを追加する要素
     * @param {string} message - 表示するエラーメッセージ
     * @returns {void}
     */
    addErrorMessage(elem, message) {
        elem.classList.add(validationClasses.err);
        elem.classList.remove(validationClasses.through);
        let errText = elem.nextElementSibling;
        if (!errText || !errText.classList.contains(validationClasses.err)) {
            errText = document.createElement("p");
            errText.classList.add(validationClasses.err);
            elem.insertAdjacentElement("afterend", errText);
        }
        errText.textContent = message;
    }
    /**
     * 送信ボタンの表示・非表示を行うメソッド
     * @method toggleSubmitButton
     * @returns {void}
     */
    toggleSubmitButton() {
        var _a, _b;
        if (this.debugs)
            console.log("toggleSubmitButton:", this.isValidForm());
        if (this.isValidForm()) {
            const classNames = this.noInputConfig.classes.split(" ");
            const errorBox = document.querySelector(`.${classNames[0]}`);
            if (errorBox) {
                errorBox.insertAdjacentElement("afterend", this.cloneSubmit);
                errorBox.remove();
            }
        }
        else {
            this.btnSubmit = document.querySelector(`.${validationClasses.btnSubmit}`);
            if (this.btnSubmit) {
                const errorBox = `<p class="${this.noInputConfig.classes}"><span>${this.noInputConfig.errText}</span></p>`;
                (_a = this.btnSubmit) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML("afterend", errorBox);
                (_b = this.btnSubmit) === null || _b === void 0 ? void 0 : _b.remove();
            }
        }
    }
    /**
     * フォーム全体のバリデーションチェックを行うメソッド
     * @method isValidForm
     * @returns {boolean} - バリデーションエラーがない場合は true、エラーがある場合は false を返す。
     */
    isValidForm() {
        const flags = [];
        const requiredFields = Array.from(this.allFields).filter((field) => {
            var _a, _b;
            return field.classList.contains((_a = this.validationConfig.required.check) !== null && _a !== void 0 ? _a : "") || field.classList.contains((_b = validationClasses.anyRequired) !== null && _b !== void 0 ? _b : "");
        });
        for (const field of requiredFields) {
            const validationFlag = field.classList.contains(validationClasses.anyRequired) ? this.anyRequiredValidator(field) : this.allCheckValidator(field);
            flags.push(validationFlag);
        }
        for (const field of this.allFields) {
            const validationFlag = this.allCheckValidator(field);
            flags.push(validationFlag);
        }
        return !flags.some((result) => result.through === 0);
    }
}
//# sourceMappingURL=topValidation.js.map